import React, { useEffect } from "react";
import Editor from "../../../form/Editor";
import Input from "../../../form/Input";
import Select from "../../../form/Select";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import useMutation from "../../../../hooks/useMutation";
import { testimonialsAddEdit } from "../../../../services/testimonialsService";
import DatePicker from "../../../form/DatePicker";
import FileUploadSingle from "../../../form/FileUploadSingle";

const validation = {
  name: { required: true, message: "User name is required" },
  comments: { required: true, message: "Comments is required" },
};

const ManageTestimonials = ({
  getResponse = () => {},
  close = () => {},
  data,
}) => {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({
    validationRules: validation,
    initialState: {
      name: "",
      dateofSubmission: "",
      address: "",
      comments: "",
      status: "",
      rating: "",
      image: "",
    },
  });

  useEffect(() => {
    if (data?._id) {
      setFieldsValue({ ...data, image: data?.image?.url });
    }
  }, [data]);

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      return await testimonialsAddEdit({
        ...val,
        ...(data?._id && { id: data?._id }),
      });
    },
    onSuccess: (res) => {
      getResponse(res);
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="grid grid-cols-12 gap-x-4 gap-y-4">
        <div className="relative col-span-12">
          <Input
            label="User's Name"
            inputPlaceholder={"Enter  User's Name"}
            inputName="name"
            value={values?.name}
            onChange={handleChange}
            {...formValidate(errors, "name")}
          />
        </div>
        <div className="relative col-span-6">
          <DatePicker
            type="input"
            label={"Date of Submission"}
            placeholder="Enter Date of Submission"
            value={{
              startDate: values?.dateofSubmission,
              endDate: values?.dateofSubmission,
            }}
            onChange={(e) => {
              handleChange({
                target: { value: e?.startDate, name: "dateofSubmission" },
              });
            }}
            {...formValidate(errors, "dateofSubmission")}
          />
        </div>
        <div className="relative col-span-6">
          <Input
            label="User's Location"
            inputPlaceholder={"Enter  User's Location"}
            inputName="address"
            value={values?.address}
            onChange={handleChange}
            {...formValidate(errors, "address")}
          />
        </div>
        <div className="relative col-span-12">
          <Editor
            label="Testimony Text"
            placeholder="At Vpeters family scholarship, we believe in the "
            value={values?.comments}
            onChange={(val) =>
              handleChange({
                target: { name: "comments", value: val },
              })
            }
            {...formValidate(errors, "comments")}
          />
        </div>
        <div className="relative col-span-6">
          <Select
            label={"Status"}
            placeholder="Select status"
            selectedValue={values?.status}
            dropdownData={[
              { name: "Active", value: 1 },
              { name: "InActive", value: 2 },
            ]}
            setSelectedValue={(val) => {
              handleChange({
                target: { name: "status", value: val },
              });
            }}
          />
        </div>
        {/* <div className="relative col-span-4">
          <Select
            label={"Select Rating"}
            placeholder="Select Rating"
            selectedValue={values?.rating}
            dropdownData={[
              { name: "Star 1", value: 1 },
              { name: "Star 2", value: 2 },
              { name: "Star 3", value: 3 },
              { name: "Star 4", value: 4 },
              { name: "Star 5", value: 5 },
            ]}
            setSelectedValue={(val) => {
              handleChange({
                target: { name: "rating", value: val },
              });
            }}
          />
        </div> */}
        <div className="relative col-span-6">
          <FileUploadSingle
            size="small"
            label={"User’s Photo"}
            value={values?.image}
            onChange={(file) =>
              handleChange({ target: { name: "image", value: file } })
            }
            {...formValidate(errors, "image")}
          />
        </div>
      </div>
      <div className="relative col-span-4 mt-5">
        <div className="flex items-center justify-center gap-4">
          <Button
            buttonType="submit"
            buttonLabel={"Save"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            {...(isLoading && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
          <Button
            buttonLabel={"Cancel"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            buttonFunction={close}
          />
        </div>
      </div>
    </form>
  );
};

export default ManageTestimonials;
